define(['app/modules/map', 'app/modules/forms'], function (googleMap, Forms) {

  var addFieldsToForm = function(form, fields) {
    $.each(fields, function(key, val){
      var input = $('<input>').attr('type', 'hidden').attr('name', key).val(val);
      form.append(input);
    });
  };

  var addFieldsToOfficesForm = function(office, coords) {
    var attrId = office.find('[name$="[country]"]').attr('name').match(/company\[offices_attributes\]\[(\d+)]/)[1];
    $.each(coords, function(key, val){
      var input = $('<input>').attr('type', 'hidden').attr('name', 'company[offices_attributes]['+attrId+']['+key+']').val(val);
      office.append(input);
    });
  };

  var getHeadquartersAddress = function(parent) {
    var fields = ['country', 'city', 'street', 'postcode'];
    var addressFields = fields.map(function(name) { return parent.find('[name="company[headquarters_attributes]['+name+']"]').val() });
    return addressFields.filter(function(i){ return i != '' }).join(', ');
  };

  var getCompanyOfficeAddress = function(parent) {
    var fields = ['country', 'city', 'street'];
    var addressFields = fields.map(function(name) { return parent.find('[name$="['+name+']"]').val() });
    return addressFields.filter(function(i){ return i != '' }).join(', ');
  };

  var setHeadquartersCoords = function(geocoder, address, map, form, data) {
    return new Promise((resolve, reject)=>{
      googleMap.geoLocate(geocoder, address, map).then((marker)=>{
        if (data && data.company_location && data.company_location.lat && data.company_location.lon) return;
        addFieldsToForm(form, {'company[lat]': marker.position.lat(), 'company[lon]': marker.position.lng()});
        Forms.submit(form, 'company_', resolve);
      });
    });
  };

  var updateCompanyLocations = function(form, data) {
    return new Promise((resolve, reject)=>{
      var geocoder_office = new google.maps.Geocoder(), officesLocations = {}, geolocatePromises = [],
        emptyLocations = data && data.locations && data.locations.filter(function (i) { return !(i.lat && i.lon) }) || [];
      var mapPromise
      $.each(emptyLocations, function(_, v){ officesLocations[v.id] = v });
      form.find('.office').each(function () {
        var officeId = $(this).data('id');
        mapPromise = googleMap.init($(this).find('.photo-column div')[0]).then(map => {
          var address = getCompanyOfficeAddress($(this).find('.list-column .content'));

          if (address == '') return;

          var geolocatePromise = googleMap.geoLocate(geocoder_office, address, map).then((marker)=>{
            if(officesLocations[officeId]) addFieldsToOfficesForm($(this), {lat: marker.position.lat(), lon: marker.position.lng()});
          });

          if(officesLocations[officeId]) geolocatePromises.push(geolocatePromise);
        })
      });
      mapPromise.then(() => {
        geolocatePromises.length && Promise.all(geolocatePromises).then(results => {
          Forms.submit(form, 'company_', resolve);
        });
      })
    });
  };

  return {
    getHeadquartersAddress: getHeadquartersAddress,
    getCompanyOfficeAddress: getCompanyOfficeAddress,
    setHeadquartersCoords: setHeadquartersCoords,
    updateCompanyLocations: updateCompanyLocations
  };
});
